module.exports = __webpack_public_path__ + "static/media/sayur.196f9620.svg";